import i18n from "config/i18next";

i18n.addResources("es", "polygon", {
  general: "General",
  pricing: "Pricing",
  polygons: "Polígonos",
});
